export const UPDATE_MAP_BOUNDS_ACTION = 'UPDATE_MAP_BOUND_ACTION' as const;
